export default __webpack_public_path__ + "static/media/liheap-banner.8ae618f2.jpeg";